import aeonik from "components/utils/aeonik";
import type { NavigatorOptions } from "highcharts";
import colors from "tailwindcss/colors";
import tinycolor2 from "tinycolor2";

const darkNavigatorStyles: NavigatorOptions = {
  stickToMax: false,
  adaptToUpdatedData: true,
  margin: 24,
  height: 60,
  outlineWidth: 1,
  outlineColor: colors.slate[950],
  maskFill: tinycolor2(colors.slate[300]).setAlpha(0.06).toRgbString(),
  maskInside: true,
  handles: {
    enabled: true,
    lineWidth: 0,
    width: 10,
    height: 16,
    backgroundColor: colors.zinc[600],
    symbols: ["circle", "circle"],
  },
  series: {
    color: colors.white,
    lineColor: colors.zinc[950],
    lineWidth: 1.5,
    zIndex: 20,
  },
  yAxis: {
    lineWidth: 0,
    lineColor: colors.slate[950],
    gridLineWidth: 0,
    labels: {
      enabled: false,
    },
  },
  xAxis: {
    showFirstLabel: true,
    showLastLabel: false,
    lineWidth: 0,
    lineColor: colors.slate[800],
    gridLineWidth: 1,
    gridLineColor: colors.slate[800],
    labels: {
      enabled: true,
      style: {
        color: colors.slate[50],
        fontFamily: aeonik.style.fontFamily,
        fontWeight: "600",
        fontSize: "10px",
        textOutline: "none",
      },
    },
  },
};

export default darkNavigatorStyles;
